import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AllRoutes } from 'constants/routes';
import { actions } from 'core/redux/api/reports';
import { useEntitiesTable } from 'hooks/useEntitiesTable';
import { StickyTable } from 'components/organisms/sticky-table';
import { TableFooter } from 'components/organisms/tep/devices/footer';
import { tepHistoryReportSelector } from 'core/redux/selectors/reports';
import { useTepHistoryColumns } from 'hooks/reports/tep-history/useTepHistoryColumns';

export const TepReportTable: FC = () => {
  const { searchParams, page, pageSize, updatePage, updatePageSize } = useEntitiesTable(AllRoutes.TepHistoryReportView);

  const dispatch = useDispatch();
  const { history, filters } = useSelector(tepHistoryReportSelector);

  const columns = useTepHistoryColumns();

  const fetchLeases = () => {
    !!filters && dispatch(actions.tepHistory.loadHistory({ filters, no: page, size: pageSize.value }));
  };

  const tableProps = {
    isLoading: false,
    offset: 350,
    data: history?.objects || [],
    columns,
  };

  const footerProps = {
    totalCount: history?.total || 0,
    pageSize,
    page,
    onPageChange: updatePage,
    updatePageSize,
  };

  useEffect(() => {
    fetchLeases();
  }, [searchParams]);

  useEffect(() => {
    if (history?.objects?.length === 0 && page !== 1) {
      updatePage({ selected: page - 1 });
    }
  }, [history?.objects]);

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div>
          <StickyTable {...tableProps} />
        </div>
      </div>
      {!!tableProps.data?.length && <TableFooter {...footerProps} />}
    </>
  );
};
